import Vue from "vue";
import Vuex from "vuex";

import app from "./modules/app";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app
  },
  state: {
    productIndex: 0
  },
  mutations: {
    setProductIndex: (state, val) => {
      state.productIndex = val.toString();
    }
  },
  actions: {},
  getters: {
    productIndex: state => {
      return state.productIndex;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js